import { QUICK_VIEW_CONFIG } from "quickViewConfig";

export function OtherCostLines(props) {
  const { lines, otherCosts, showItemNames, objectType, record } = props;

  const tableLines = QUICK_VIEW_CONFIG[objectType].lines;
  const tableOtherCosts = QUICK_VIEW_CONFIG[objectType].otherCosts;

  if (!otherCosts.length) {
    return null;
  }

  return (
    <>
      <tr>
        <td
          colSpan={tableLines.length}
          style={{ height: "1rem", border: "none" }}
        />
      </tr>
      <tr>
        <td
          colSpan={tableLines.length}
          style={{
            fontWeight: "bold",
            textAlign: "left",
            border: "none",
            padding: 0,
          }}
        >
          Other costs
        </td>
      </tr>
      <tr className="thead">
        {tableOtherCosts.map(({ heading, isItemField, colSpan }, i) => {
          if (isItemField && !showItemNames) {
            return null;
          }
          return (
            <th colSpan={colSpan} key={i}>
              {heading}
            </th>
          );
        })}
      </tr>
      {otherCosts?.map((line, i) => {
        return (
          <tr key={i}>
            {tableOtherCosts?.map(
              ({ name, formatFunc, align, isItemField, colSpan }, i) => {
                if (isItemField && !showItemNames) {
                  return null;
                }
                return (
                  <td
                    key={i}
                    style={{ textAlign: align, whiteSpace: "pre-wrap" }}
                    colSpan={colSpan}
                  >
                    {formatFunc ? formatFunc(line[name], record) : line[name]}
                  </td>
                );
              }
            )}
          </tr>
        );
      })}
      {tableOtherCosts.find(({ footerFunc }) => footerFunc) && (
        <tr className="tfoot">
          {tableOtherCosts.map(
            ({ isItemField, footerFunc, name, colSpan }, i) => {
              if (isItemField && !showItemNames) {
                return null;
              }
              return (
                <td colSpan={colSpan} data-testing={name} key={i}>
                  {footerFunc ? footerFunc(lines, name, record) : ""}
                </td>
              );
            }
          )}
        </tr>
      )}
      <tr style={{ border: "none", padding: 0 }}>
        {tableOtherCosts.map(
          ({ name, align, colSpan, combinedFooterFunc }, i) => {
            if (name === "amount") {
              return (
                <td
                  style={{
                    border: "none",
                    textAlign: align,
                    fontWeight: "bold",
                    paddingTop: ".25rem",
                  }}
                  key={i}
                  colSpan={colSpan}
                >
                  {combinedFooterFunc
                    ? combinedFooterFunc(lines, name, record)
                    : ""}
                </td>
              );
            }
            return (
              <td
                style={{ border: "none", padding: 0 }}
                key={i}
                colSpan={showItemNames ? colSpan : colSpan - 1}
              />
            );
          }
        )}
      </tr>
    </>
  );
}
